import React from "react";

function ImageText() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="211"
      height="124"
      fill="none"
      viewBox="0 0 211 124"
    >
      <path stroke="#000" d="M0.5 0.5H210.5V102.5H0.5z"></path>
      <g fill="#9E9E9E" clip-path="url(#clip0)">
        <path
          fillRule="evenodd"
          d="M80.969 28.063H20.03a2.343 2.343 0 00-2.343 2.343v42.188a2.343 2.343 0 002.343 2.344H80.97a2.343 2.343 0 002.344-2.344V30.406a2.343 2.343 0 00-2.344-2.343zM20.03 23.375A7.031 7.031 0 0013 30.406v42.188a7.031 7.031 0 007.031 7.031H80.97A7.031 7.031 0 0088 72.594V30.406a7.031 7.031 0 00-7.031-7.031H20.03z"
          clipRule="evenodd"
        ></path>
        <path d="M62.912 49.84a2.343 2.343 0 012.705-.435l17.705 9.126v16.407H17.697V70.25L30.1 59.216a2.344 2.344 0 012.953-.29l12.469 8.31 17.39-17.39v-.005z"></path>
        <path
          fillRule="evenodd"
          d="M34.103 46.813a7.032 7.032 0 100-14.064 7.032 7.032 0 000 14.063z"
          clipRule="evenodd"
        ></path>
      </g>
      <path stroke="#000" strokeWidth="4" d="M98 25L184 25"></path>
      <path stroke="#000" strokeWidth="4" d="M98 33L152 33"></path>
      <path stroke="#000" d="M99 46.5L184 46.5"></path>
      <path stroke="#000" d="M99 50.5L184 50.5"></path>
      <path stroke="#000" d="M99 54.5L184 54.5"></path>
      <path stroke="#000" d="M99 58.5L184 58.5"></path>
      <path stroke="#000" d="M99 62.5L184 62.5"></path>
      <path stroke="#000" d="M99 66.5L184 66.5"></path>
      <path stroke="#000" strokeWidth="2" d="M99 79L145 79"></path>
      <defs>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0H75V75H0z"
            transform="translate(13 14)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ImageText;
